import React, { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { Form } from "semantic-ui-react";
import { producaov2 as api } from "../../../../../../services/apis";

import { StyledLabel, StyledButton, InputFile } from "./styles";

const FormularioParceiros = () => {
  const [nome, setNome] = useState();
  const [email, setEmail] = useState();
  const [telefone, setTelefone] = useState();
  const [instagram, setInstagram] = useState();
  const [blog, setBlog] = useState();
  const [tipo, setTipo] = useState();
  const [description, setDescription] = useState();
  const [localizacao, setLocalizacao] = useState();
  const [formacao, setFormacao] = useState();
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImageUrl, setSelectedImageUrl] = useState("");

  const HandleCadastro = async () => {
    try {
      const url = await uploadImage();

      const inputData = {
        nome: nome,
        email: email,
        telefone: telefone,
        instagram: instagram,
        blog: blog,
        tipo: tipo,
        description: description,
        localizacao: localizacao,
        formacao: formacao,
        urlamigavel: selectedImageUrl,
      };

      await api.post("/pb4y-cadastro-parceria", {
        inputData ,
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      });

      toast.success("O Cadastro do parceiro foi concluido com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error(
        "O Cadastro do parceiro falhou, verifique os dados e tente novamente",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  const handleSelectedImage = useCallback((e) => {
    const { files } = e.target;

    if (!files[0].type.includes("image")) {
      toast.error("Por favor, insira uma imagem", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    const objectURL = URL.createObjectURL(files[0]);
    setSelectedImageUrl(files[0].name);
    setSelectedImage(files[0]);
  });

  const uploadImage = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedImage);
      inputData.append(
        "path",
        "imagens-voitto/pocketbook4you/parceriasparceiros"
      );

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      toast.success("O Upload da Foto foi concluido com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      return url;
    } catch (err) {
      toast.error(
        "O Upload da Foto falhou, verifique o arquivo e tente novamente",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  return (
    <Form>
      <Form.Field>
        <StyledLabel>Nome</StyledLabel>
        <Form.Input
          type="text"
          placeholder="nome e sobrenome"
          required
          onChange={(e) => setNome(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>E-mail</StyledLabel>
        <Form.Input
          type="email"
          placeholder="xxxxxx@xxxxx.xxx"
          required
          onChange={(e) => setEmail(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Telefone</StyledLabel>
        <Form.Input
          type="tel"
          placeholder="xx xxxxx-xxxx"
          pattern="[0-9]{2} [0-9]{9}"
          required
          onChange={(e) => setTelefone(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Instagram</StyledLabel>
        <Form.Input
          type="text"
          placeholder="nome do instagram"
          required
          onChange={(e) => setInstagram(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Blog</StyledLabel>
        <Form.Input
          type="text"
          placeholder="nome do blog"
          required
          onChange={(e) => setBlog(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Tipo de parceria</StyledLabel>
        <Form.Input
          type="number"
          placeholder="1 para embaixador, 2 para blog"
          min="1"
          max="2"
          required
          onChange={(e) => setTipo(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Descrição</StyledLabel>
        <Form.Input
          type="text"
          placeholder="ate 200 caracteres"
          required
          onChange={(e) => setDescription(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Localização</StyledLabel>
        <Form.Input
          type="text"
          placeholder="cidade, estado"
          required
          onChange={(e) => setLocalizacao(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Formação</StyledLabel>
        <Form.Input
          type="text"
          placeholder="formação"
          required
          onChange={(e) => setFormacao(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Foto do Aluno</StyledLabel>
        <InputFile type="file" onChange={(e) => handleSelectedImage(e)} />
      </Form.Field>

      <StyledButton onClick={HandleCadastro}>
        <i class="plus icon" />
        Criar
      </StyledButton>
    </Form>
  );
};

export default FormularioParceiros;
